import { PriceList } from "../modules";

export const PriceListPage = () => {
  return <PriceList />;
};
